import { Component } from 'react'
import Form from '../../../components/forms/form'
import FormGroup from '../../../components/forms/form_group'
import TextArea from '../../../components/forms/text_area'
import AuthenticityToken from '../../../components/forms/authenticity_token'

export default class NewCommentForm extends Component {
  render() {
    const { path } = this.props
    return (
      <div className="timeline-comments__new-comment">
        <h4 className="heading">Leave a comment</h4>
        <Form className="form form--limited-inputs" action={path} ignoreMissingSubmitHandler={true}>
          <AuthenticityToken />
          <FormGroup>
            <TextArea id="comment_comment" name="comment[comment]" className="textarea" />
            <div className="tip">You can add html links, but they must include 'http://'</div>
          </FormGroup>

          <FormGroup className="form-group form-group-buttons form-group-buttons--left">
            <div className="form-group-buttons__container">
              <input className="btn btn--primary" type="submit" value="Add Comment +" name="commit" />
            </div>
          </FormGroup>
        </Form>
      </div>
    )
  }
}
